import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const MinpakuList = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("admin_jwt");
    if (!token) {
      setList([]);
      return;
    }
    const fetchList = async () => {
      try {
        // 全件取得（並び替えのため）
        const res = await fetch(`/api/admin/minpaku?limit=0`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const json = await res.json();
        if (Array.isArray(json.data)) setList(json.data);
        else console.error("Invalid response format", json);
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };
    fetchList();
  }, []);

  // 表示順の並び替え（▲▼）＋ 永続化
  const move = async (index, dir) => {
    const to = index + dir;
    if (to < 0 || to >= list.length) return;
    const arr = [...list];
    [arr[index], arr[to]] = [arr[to], arr[index]];
    setList(arr);
    const token = localStorage.getItem("admin_jwt");
    try {
      await fetch("/api/admin/minpaku", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ reorder: true, ids: arr.map((x) => x.id) }),
      });
    } catch (err) {
      console.error("並び替えの保存に失敗:", err);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="adm-title">民泊一覧</h1>
        <Link to="/admin/minpaku/new" className="adm-btn">
          ＋ 追加
        </Link>
      </div>
      <p className="text-xs text-gray-500 mb-2">
        ▲▼ で表示順を変更できます（公開ページにも反映されます）。
      </p>

      <div className="adm-card p-0 overflow-hidden">
        <ul className="divide-y divide-gray-100">
          {list.map((item, i) => (
            <li
              key={item.id}
              className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition"
            >
              <div className="flex flex-col">
                <button
                  type="button"
                  onClick={() => move(i, -1)}
                  disabled={i === 0}
                  className="text-gray-500 disabled:opacity-30 leading-none"
                  aria-label="上へ"
                >
                  ▲
                </button>
                <button
                  type="button"
                  onClick={() => move(i, 1)}
                  disabled={i === list.length - 1}
                  className="text-gray-500 disabled:opacity-30 leading-none"
                  aria-label="下へ"
                >
                  ▼
                </button>
              </div>
              <Link
                to={`/admin/minpaku/${item.id}`}
                className="flex-1 min-w-0 flex items-center gap-2"
              >
                <span className="font-medium text-gray-800 truncate">
                  {item.name}
                </span>
                {item.published === false && (
                  <span className="shrink-0 text-xs px-2 py-0.5 rounded-full bg-gray-200 text-gray-600">
                    非公開
                  </span>
                )}
              </Link>
              <span className="text-sm text-gray-500 shrink-0">
                {item.createdAt
                  ? new Date(item.createdAt).toLocaleDateString("ja-JP", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  : ""}
              </span>
            </li>
          ))}
          {list.length === 0 && (
            <li className="px-4 py-8 text-center text-gray-400 text-sm">
              物件がありません
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default MinpakuList;
